// Announcement only: this campaign never controls billing or platform access.
export const septemberFreeAccessCampaign = {
  id: "september-free-access-2026",
  enabled: true,
  // October 1, 2026 at 00:00 Europe/Athens (EEST, UTC+03:00).
  expiresAt: Date.parse("2026-09-30T21:00:00.000Z"),
};

export const isFreeAccessCampaignActive = (now = Date.now()) =>
  septemberFreeAccessCampaign.enabled &&
  now < septemberFreeAccessCampaign.expiresAt;

export const getFreeAccessDismissalKey = (userId) =>
  userId
    ? `playerdex:announcement:${
        septemberFreeAccessCampaign.id
      }:${encodeURIComponent(String(userId))}`
    : null;
